import { ShimmeredDetailsList } from "@components/tables/ShimmeredDetailsList";
import { withPermissions } from "@components/withPermissions";
import { FunctionComponent } from "react";

import { Card, IColumn } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { CommPreference } from "@libs/api/gateways/ttm/comms/ttm-comms-ops-gateway.dtos";
import { useCommPreferences } from "@libs/api/gateways/ttm/comms/ttm-comms-ops-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";

interface Props {
  tenant: Tenant;
}

const cardStyles = {
  subComponentStyles: {
    tile: {
      content: {
        padding: 0
      }
    }
  }
};

const CommsPreferencesCardBase: FunctionComponent<Props> = ({
  tenant: { id: tenantId }
}) => {
  const commsPreferencesQuery = useCommPreferences(tenantId);

  const columns: IColumn[] = [
    {
      key: "commsPreferenceId",
      name: "Id",
      onRender: (item: CommPreference) => item.id,
      minWidth: 300,
      maxWidth: 350
    },
    {
      key: "commsPreferenceJson",
      name: "JSON",
      onRender: (item: CommPreference) => JSON.stringify(item.preferenceData),
      minWidth: 300,
      isMultiline: true
    }
  ];

  return (
    <Card
      iconName="Settings"
      headingLevel="section-heading"
      heading="Comms Preferences"
      styles={cardStyles}
    >
      <QueryStateIndicator {...commsPreferencesQuery}>
        {data => {
          return <ShimmeredDetailsList items={data} columns={columns} />;
        }}
      </QueryStateIndicator>
    </Card>
  );
};

export const CommsPreferencesCard = withPermissions(CommsPreferencesCardBase, [
  Permissions.TiSettingsRead
]);
